/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KEEP_PATH } from '../pin-action/community-profile-pin-action.component';

// The "Pinned" label visitors see above someone's pinned post (PINNED_POST_OPTIONS.html option B).
// Projected into the feed card with `feedItemLabel`; renders nothing unless the item is pinned.
@Component({
  selector: 'ut-community-profile-pinned-label',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (pinned) {
      <p class="pinned-label">
        <svg class="pinned-label__icon" viewBox="0 -960 960 960" aria-hidden="true"><path fill="currentColor" [attr.d]="keepPath"/></svg>
        Pinned
      </p>
    }
  `,
  styles: [`
    .pinned-label {
      display: flex;
      align-items: center;
      gap: var(--spacing-xs);
      margin: 0 0 var(--spacing-md);
      color: var(--text-tertiary);
      font-size: var(--text-xs);
      line-height: var(--text-xs-lh);
      font-weight: 600;
    }

    .pinned-label__icon {
      width: 1.6rem;
      height: 1.6rem;
      color: var(--fg-tertiary);
    }
  `],
})
export class CommunityProfilePinnedLabelComponent {
  @Input({ required: true }) item: any;

  readonly keepPath = KEEP_PATH;

  // The author's pinned_content holds one pinned id per type.
  get pinned(): boolean {
    return this.item.user?.pinned_content?.[`${this.item.type}_id`] === this.item.id;
  }
}
